import React, { useState } from "react";
import { MoreVert as MoreVertIcon } from "@mui/icons-material";
import { IconButton, Menu, MenuItem, TableBody, TableCell, TableHead, TableRow, Tooltip } from "@mui/material";
import { Lock as LockIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

import { User } from "src/types";
import { StickyTable } from "./StickyTable";
import { useUserDeleteMutation } from "src/hooks/users";
import { useConfirm } from "material-ui-confirm";

interface Props {
  className?: string;
  data: User[];
}

export function UsersTable(props: Props) {
  const { t } = useTranslation();
  const { data } = props;

  return render();

  function render() {
    return (
      <StickyTable className={props.className}>
        <TableHead>
          <TableRow>
            <TableCell>{t("label.firstName")}</TableCell>
            <TableCell>{t("label.lastName")}</TableCell>
            <TableCell>{t("label.email")}</TableCell>
            <TableCell>{t("label.created")}</TableCell>
            <TableCell>{t("label.role")}</TableCell>
            <TableCell></TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((item) => (
            <TableRow key={item.id}>
              <TableCell component="th" scope="row">
                {item.firstName}
              </TableCell>
              <TableCell>{item.lastName}</TableCell>
              <TableCell>{item.email}</TableCell>
              <TableCell>{t("label.dateCreated", { date: item.dateCreated })}</TableCell>
              <TableCell>{t(`label.userRoles.${item.role}`)}</TableCell>
              <TableCell>
                {!item.enabled && (
                  <Tooltip title={t<string>("label.thisUserIsDisabled")}>
                    <LockIcon fontSize="small" color="action" />
                  </Tooltip>
                )}
              </TableCell>
              <TableCell align="right">
                <RowActions data={item} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </StickyTable>
    );
  }
}

function RowActions(props: { data: User }) {
  const { data } = props;
  const { t } = useTranslation();
  const confirm = useConfirm();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  // // TODO: refactor into hook
  // const setDefaultMutation = useMutation(CustomMeteoService.setDefault, {
  //   onSuccess: () => queryClient.invalidateQueries('custommeteo'),
  // });

  // // TODO: refactor into hook
  const deleteMutation = useUserDeleteMutation();

  function handleClick(event: React.MouseEvent<HTMLButtonElement>) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  // function handleSetAsDefault() {
  //   setDefaultMutation.mutate(data.id);
  //   handleClose();
  // }

  function handleDelete() {
    confirm({
      confirmationButtonProps: { autoFocus: true },
      title: t("label.areYouSure"),
      description: t("confirm.deleteUser", {
        name: [data.firstName, data.lastName].join(" "),
      }),
    })
      .then(() => deleteMutation.mutate(data.id))
      .finally(() => handleClose());
  }

  return render();

  function render() {
    return (
      <>
        <IconButton onClick={handleClick} size="large">
          <MoreVertIcon />
        </IconButton>
        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
          <MenuItem
            // onClick={handleEdit}
            component={NavLink}
            to={`/users/${data.id}`}
          >
            {t("label.edit")}
          </MenuItem>
          <MenuItem onClick={handleDelete}>{t("label.delete")}</MenuItem>
        </Menu>
      </>
    );
  }
}
